import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';

import Service from '@/service/index.js';
import PublishProjectService from '../publish-project-service.js';
import { errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    ProcessNavigation
  },
  data() {
    const validateBidType = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择竞价方式'));
      } else if (value && ((value === '1') || value === '2')) {
        if (!this.ruleForm.increaseAmount) {
          callback(new Error('请输入加价幅度!'));
        } else if (this.ruleForm.increaseAmount && this.ruleForm.increaseAmount <= 0) {
          callback(new Error('加价幅度需要大于0!'));
        }  else if (this.ruleForm.increaseAmount && this.ruleForm.increaseAmount % 10 !== 0) {
          callback(new Error('请输入10的整数倍的加价幅度!'));
        } else if (!this.ruleForm.increaseTime) {
          callback(new Error('请选择限时报价周期!'));
        } else if (this.ruleForm.increaseTime && (this.ruleForm.increaseTime < 60 || !/^[0-9]*$/.test(this.ruleForm.increaseTime))) {
          callback(new Error('请输入大于等于60的正整数限时报价周期!'));
        } else {
          callback();
        }
      } else if (value && ((value === '4') || value === '5')) {
        if (!this.ruleForm.increaseAmount) {
          callback(new Error('请输入加价幅度!'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      processList: ['业务流程及准备材料', '编辑项目信息', '编辑受让资格', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'],
      unBidSelArr: [],
      bidTypeArr: [],
      qualificationRestrictionList: [],
      id: '',
      oldId: '',
      tradeType: '',
      isCreated: true,
      ruleForm: {
        assignmentCondition: '',
        unBidSel: '',
        bidType: '',
        increaseAmount: 100,
        increaseTime: '60',
        qualificationRestriction: '1',
        offlineBidLocatioin: ''
      },
      increaseTimeDate: [
        {code: '60', value: '60'},
        {code: '120', value: '120'},
        {code: '180', value: '180'},
        {code: '240', value: '240'},
        {code: '300', value: '300'}
      ],
      rules: {
        unBidSel: [
          {required: true, message: '请选择未征集到选择', trigger: 'change'}
        ],
        bidType: [
          {required: true, validator: validateBidType, trigger: 'change'}
        ],
        qualificationRestriction: [
          {required: true, message: '请选择受让方资格限制', trigger: 'change'}
        ],
        offlineBidLocatioin: [
          {required: true, message: '请输入线下竞价地址', trigger: 'change'}
        ]
      },
      projectType: 1, // 项目类型
      projectSubType: 1, // 项目子类
      conditionList: {},
      isLease: false // 是否为农机设备出租
    };
  },
  computed: {
    ...mapGetters([
      'getTenantParams'
    ]),
    increaseAmountList() {
      if (['颍上县', '安徽临泉'].includes(this.getTenantParams.citytitle)) {
        return ['10', '100', '500', '1000', '2000', '3000', '5000', '8000', '10000', '20000', '30000', '50000'];
      }
      return ['10', '100', '500', '1000', '5000', '10000'];
    },
    content() {
      const type = String(this.projectType);
      if (['颍上县', '安徽临泉'].includes(this.getTenantParams.citytitle) && ['1', '2', '3', '4', '9'].includes(type)) {
        return '不变更公告内容，按照10个工作日为一个周期延长，直至征集到意向受让方';
      }
      return '不变更公告内容，按照5个工作日为一个周期延长，直至征集到意向受让方';
    }
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    this.projectType = this.$route.query.projectType; // 项目类型
    this.projectSubType = this.$route.query.projectSubType; // 项目子类
    this.tradeType = this.$route.query.tradeType;
    // 是否为农机设备出租
    if((Number(this.projectType) === 7 && Number(this.projectSubType) === 2) || Number(this.projectType) === 6) {
      this.isLease = true;
    }
    this.conditionList = {
      '1-1': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。',
        '3.对地上附着物有管护责任，标的原地上附着物在合同到期时保持完好，新建附着物应征得转让方同意。'
      ],
      '1-2': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。',
        '3.对地上附着物有管护责任，标的原地上附着物在合同到期时保持完好，新建附着物应征得转让方同意。'
      ],
      '2-2': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。',
        '3.对地上附着物有管护责任，新建附着物应征得转让方同意。'
      ],
      '2-3': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。'
      ],
      '2-1': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。',
        '3.对地上附着物有管护责任，新建附着物应征得转让方同意。'
      ],
      '3-1': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。'
      ],
      '4-1': [
        '1.必须为合法存续的法定代表人、非法定代表人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。',
        '3.对地上附着物有管护责任，标的原地上附着物在合同到期时保持完好，新建附着物应征得转让方同意。'
      ],
      '4-2': [
        '1.必须为合法存续的法定代表人、非法定代表人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。',
        '3.对地上附着物有管护责任，标的原地上附着物在合同到期时保持完好，新建附着物应征得转让方同意。'
      ],
      '4-3': [
        '1.必须为合法存续的法定代表人、非法定代表人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。',
        '3.对地上附着物有管护责任，标的原地上附着物在合同到期时保持完好，新建附着物应征得转让方同意。'
      ],
      '4-4': [
        '1.必须为合法存续的法定代表人、非法定代表人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。',
        '3.对地上附着物有管护责任，标的原地上附着物在合同到期时保持完好，新建附着物应征得转让方同意。'
      ],
      '6-1': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。'
      ],
      '6-2': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。'
      ],
      '6-3': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。'
      ],
      '7-1': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。'
      ],
      '7-2': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。'
      ],
      '8-1': [
        '1.必须为合法存续的法人、非法人组织或具有完全民事行为能力的自然人。',
        '2.符合有关法律法规规定的相关条件。'
      ]
    };
    if (this.id) {
      this.getNewsTransfereeInfo().then(() => {}, () => {
        if (this.oldId) {
          this.getOldTransfereeInfo();
        }
      });
    }
    const arr = [
      ['unBidSelArr', 'NOT_SOLICITED_CHOOSE'], ['bidTypeArr', 'BIDDING_METHOD'], ['qualificationRestrictionList', 'QUALIFICATION_RESTRICTION']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
          console.log(this.isLease);
          // 如果是农机设备出租 或者 建筑物出租
          // if(this.isLease) {
          //   // this.unBidSelArr[1].description = '不变更公告内容，按照5个工作日为一个周期延长，直至征集到意向承租方';
          // }
        }
      });
    });
  },

  methods: {
    getNewsTransfereeInfo () {
      return new Promise((resolve, reject) => {
        PublishProjectService.getProjectInfo({
          projectId: this.id,
          echoCode: 'ASSIGNMENT'
        }).then(res => {
          if (!res.data) {
            reject();
          } else {
            this.isCreated = false;
            Object.keys(this.ruleForm).forEach((key) => {
              if (res.data && res.data[key] &&
                ((typeof res.data[key] === 'string') ||
                (typeof res.data[key] === 'number'))) {
                this.ruleForm[key] = res.data && String(res.data[key]);
              }
            });
            resolve();
          }
        });
      });
    },
    getOldTransfereeInfo () {
      PublishProjectService.getProjectInfo({
        projectId: this.oldId,
        echoCode: 'ASSIGNMENT'
      }).then(res => {
        if (!res.data) {
          return;
        }
        this.isCreated = true;
        Object.keys(this.ruleForm).forEach((key) => {
          if (res.data && res.data[key] &&
            ((typeof res.data[key] === 'string') ||
            (typeof res.data[key] === 'number'))) {
            this.ruleForm[key] = res.data && String(res.data[key]);
          }
        });
      });
    },
    previousStep () {
      let str = '';
      if (this.id && this.oldId) {
        str = '?id=' + this.id + '&oldId=' + this.oldId;
      } else if (this.id) {
        str = '?id=' + this.id;
      } else {
        str = '?oldId=' + this.oldId;
      }
      this.$router.replace('/publish-project/project-info' + str);
    },
    isShowIncreaseAmount (index) {
      if (this.ruleForm.bidType && ((String(index + 1)) === this.ruleForm.bidType) && (this.ruleForm.bidType !== '3')) {
        return true;
      }
      return false;
    },
    isShowIncreaseTime (index) {
      if (this.ruleForm.bidType && ((String(index + 1)) === this.ruleForm.bidType) && ((this.ruleForm.bidType === '1')
      || (this.ruleForm.bidType === '2'))) {
        return true;
      }
      return false;
    },
    next() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          if (this.isCreated) {
            this.saveTransfereeInfo();
          } else {
            this.updateTransfereeInfo();
          }
        } else {
          return false;
        }
      });
    },
    saveTransfereeInfo () {
      PublishProjectService.saveTransfereeInfo({
        projectId: this.id,
        ...this.ruleForm
      }).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push('/publish-project/attachment-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + this.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType );
          } else {
            this.$router.push('/publish-project/attachment-info?id=' + this.id + '&tradeType=' + this.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType);
          }
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存受让信息失败');
        }
      });
    },
    updateTransfereeInfo () {
      PublishProjectService.updateTransfereeInfo({
        projectId: this.id,
        ...this.ruleForm
      }).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push('/publish-project/attachment-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + this.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType );
          } else {
            this.$router.push('/publish-project/attachment-info?id=' + this.id + '&tradeType=' + this.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType);
          }
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存受让信息失败');
        }
      });
    }
  }
};
